import SignInForm from 'features/auth/components/organisms/SignInForm/SignInForm';

export default SignInForm;
